var Pt = Object.defineProperty;
var Nt = (e, t, r) => t in e ? Pt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var R = (e, t, r) => (Nt(e, typeof t != "symbol" ? t + "" : t, r), r);
import * as d from "react";
import A from "react";
import Ae from "react/jsx-dev-runtime";
import _e, { jsx as w } from "react/jsx-runtime";
import Ft from "react-dom";
import * as D from "@tanstack/react-query";
function _(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function X(e, t = []) {
  let r = [];
  function n(s, i) {
    const c = d.createContext(i), a = r.length;
    r = [...r, i];
    const u = (f) => {
      var v;
      const { scope: h, children: g, ...y } = f, m = ((v = h == null ? void 0 : h[e]) == null ? void 0 : v[a]) || c, x = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ w(m.Provider, { value: x, children: g });
    };
    u.displayName = s + "Provider";
    function p(f, h) {
      var m;
      const g = ((m = h == null ? void 0 : h[e]) == null ? void 0 : m[a]) || c, y = d.useContext(g);
      if (y)
        return y;
      if (i !== void 0)
        return i;
      throw new Error(`\`${f}\` must be used within \`${s}\``);
    }
    return [u, p];
  }
  const o = () => {
    const s = r.map((i) => d.createContext(i));
    return function(c) {
      const a = (c == null ? void 0 : c[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: a } }),
        [c, a]
      );
    };
  };
  return o.scopeName = e, [n, jt(o, ...t)];
}
function jt(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(s) {
      const i = n.reduce((c, { useScope: a, scopeName: u }) => {
        const f = a(s)[`__scope${u}`];
        return { ...c, ...f };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function pe(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Ie(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((o) => {
      const s = pe(o, t);
      return !r && typeof s == "function" && (r = !0), s;
    });
    if (r)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const s = n[o];
          typeof s == "function" ? s() : pe(e[o], null);
        }
      };
  };
}
function B(...e) {
  return d.useCallback(Ie(...e), e);
}
// @__NO_SIDE_EFFECTS__
function J(e) {
  const t = /* @__PURE__ */ Lt(e), r = d.forwardRef((n, o) => {
    const { children: s, ...i } = n, c = d.Children.toArray(s), a = c.find(Dt);
    if (a) {
      const u = a.props.children, p = c.map((f) => f === a ? d.Children.count(u) > 1 ? d.Children.only(null) : d.isValidElement(u) ? u.props.children : null : f);
      return /* @__PURE__ */ w(t, { ...i, ref: o, children: d.isValidElement(u) ? d.cloneElement(u, void 0, p) : null });
    }
    return /* @__PURE__ */ w(t, { ...i, ref: o, children: s });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function Lt(e) {
  const t = d.forwardRef((r, n) => {
    const { children: o, ...s } = r;
    if (d.isValidElement(o)) {
      const i = kt(o), c = Bt(s, o.props);
      return o.type !== d.Fragment && (c.ref = n ? Ie(n, i) : i), d.cloneElement(o, c);
    }
    return d.Children.count(o) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Ut = Symbol("radix.slottable");
function Dt(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Ut;
}
function Bt(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], s = t[n];
    /^on[A-Z]/.test(n) ? o && s ? r[n] = (...c) => {
      s(...c), o(...c);
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...s } : n === "className" && (r[n] = [o, s].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function kt(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function Gt(e) {
  const t = e + "CollectionProvider", [r, n] = X(t), [o, s] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: x, children: v } = m, C = A.useRef(null), l = A.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ w(o, { scope: x, itemMap: l, collectionRef: C, children: v });
  };
  i.displayName = t;
  const c = e + "CollectionSlot", a = /* @__PURE__ */ J(c), u = A.forwardRef(
    (m, x) => {
      const { scope: v, children: C } = m, l = s(c, v), b = B(x, l.collectionRef);
      return /* @__PURE__ */ w(a, { ref: b, children: C });
    }
  );
  u.displayName = c;
  const p = e + "CollectionItemSlot", f = "data-radix-collection-item", h = /* @__PURE__ */ J(p), g = A.forwardRef(
    (m, x) => {
      const { scope: v, children: C, ...l } = m, b = A.useRef(null), S = B(x, b), T = s(p, v);
      return A.useEffect(() => (T.itemMap.set(b, { ref: b, ...l }), () => void T.itemMap.delete(b))), /* @__PURE__ */ w(h, { [f]: "", ref: S, children: C });
    }
  );
  g.displayName = p;
  function y(m) {
    const x = s(e + "CollectionConsumer", m);
    return A.useCallback(() => {
      const C = x.collectionRef.current;
      if (!C)
        return [];
      const l = Array.from(C.querySelectorAll(`[${f}]`));
      return Array.from(x.itemMap.values()).sort(
        (T, $) => l.indexOf(T.ref.current) - l.indexOf($.ref.current)
      );
    }, [x.collectionRef, x.itemMap]);
  }
  return [
    { Provider: i, Slot: u, ItemSlot: g },
    y,
    n
  ];
}
var Z = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, Wt = d[" useId ".trim().toString()] || (() => {
}), qt = 0;
function $e(e) {
  const [t, r] = d.useState(Wt());
  return Z(() => {
    e || r((n) => n ?? String(qt++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var Kt = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], L = Kt.reduce((e, t) => {
  const r = /* @__PURE__ */ J(`Primitive.${t}`), n = d.forwardRef((o, s) => {
    const { asChild: i, ...c } = o, a = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w(a, { ...c, ref: s });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function ee(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function Oe({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [n, o] = zt({ defaultProp: t, onChange: r }), s = e !== void 0, i = s ? e : n, c = ee(r), a = d.useCallback(
    (u) => {
      if (s) {
        const f = typeof u == "function" ? u(e) : u;
        f !== e && c(f);
      } else
        o(u);
    },
    [s, e, o, c]
  );
  return [i, a];
}
function zt({
  defaultProp: e,
  onChange: t
}) {
  const r = d.useState(e), [n] = r, o = d.useRef(n), s = ee(t);
  return d.useEffect(() => {
    o.current !== n && (s(n), o.current = n);
  }, [n, o, s]), r;
}
var Jt = d.createContext(void 0);
function Me(e) {
  const t = d.useContext(Jt);
  return e || t || "ltr";
}
var z = "rovingFocusGroup.onEntryFocus", Zt = { bubbles: !1, cancelable: !0 }, G = "RovingFocusGroup", [H, Pe, Ht] = Gt(G), [Vt, Ne] = X(
  G,
  [Ht]
), [Yt, Qt] = Vt(G), Fe = d.forwardRef(
  (e, t) => /* @__PURE__ */ w(H.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ w(H.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ w(Xt, { ...e, ref: t }) }) })
);
Fe.displayName = G;
var Xt = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: n,
    loop: o = !1,
    dir: s,
    currentTabStopId: i,
    defaultCurrentTabStopId: c,
    onCurrentTabStopIdChange: a,
    onEntryFocus: u,
    preventScrollOnEntryFocus: p = !1,
    ...f
  } = e, h = d.useRef(null), g = B(t, h), y = Me(s), [m = null, x] = Oe({
    prop: i,
    defaultProp: c,
    onChange: a
  }), [v, C] = d.useState(!1), l = ee(u), b = Pe(r), S = d.useRef(!1), [T, $] = d.useState(0);
  return d.useEffect(() => {
    const E = h.current;
    if (E)
      return E.addEventListener(z, l), () => E.removeEventListener(z, l);
  }, [l]), /* @__PURE__ */ w(
    Yt,
    {
      scope: r,
      orientation: n,
      dir: y,
      loop: o,
      currentTabStopId: m,
      onItemFocus: d.useCallback(
        (E) => x(E),
        [x]
      ),
      onItemShiftTab: d.useCallback(() => C(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => $((E) => E + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => $((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ w(
        L.div,
        {
          tabIndex: v || T === 0 ? -1 : 0,
          "data-orientation": n,
          ...f,
          ref: g,
          style: { outline: "none", ...e.style },
          onMouseDown: _(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: _(e.onFocus, (E) => {
            const It = !S.current;
            if (E.target === E.currentTarget && It && !v) {
              const fe = new CustomEvent(z, Zt);
              if (E.currentTarget.dispatchEvent(fe), !fe.defaultPrevented) {
                const K = b().filter((M) => M.focusable), $t = K.find((M) => M.active), Ot = K.find((M) => M.id === m), Mt = [$t, Ot, ...K].filter(
                  Boolean
                ).map((M) => M.ref.current);
                Ue(Mt, p);
              }
            }
            S.current = !1;
          }),
          onBlur: _(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), je = "RovingFocusGroupItem", Le = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: n = !0,
      active: o = !1,
      tabStopId: s,
      ...i
    } = e, c = $e(), a = s || c, u = Qt(je, r), p = u.currentTabStopId === a, f = Pe(r), { onFocusableItemAdd: h, onFocusableItemRemove: g } = u;
    return d.useEffect(() => {
      if (n)
        return h(), () => g();
    }, [n, h, g]), /* @__PURE__ */ w(
      H.ItemSlot,
      {
        scope: r,
        id: a,
        focusable: n,
        active: o,
        children: /* @__PURE__ */ w(
          L.span,
          {
            tabIndex: p ? 0 : -1,
            "data-orientation": u.orientation,
            ...i,
            ref: t,
            onMouseDown: _(e.onMouseDown, (y) => {
              n ? u.onItemFocus(a) : y.preventDefault();
            }),
            onFocus: _(e.onFocus, () => u.onItemFocus(a)),
            onKeyDown: _(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget)
                return;
              const m = rr(y, u.orientation, u.dir);
              if (m !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey)
                  return;
                y.preventDefault();
                let v = f().filter((C) => C.focusable).map((C) => C.ref.current);
                if (m === "last")
                  v.reverse();
                else if (m === "prev" || m === "next") {
                  m === "prev" && v.reverse();
                  const C = v.indexOf(y.currentTarget);
                  v = u.loop ? nr(v, C + 1) : v.slice(C + 1);
                }
                setTimeout(() => Ue(v));
              }
            })
          }
        )
      }
    );
  }
);
Le.displayName = je;
var er = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function tr(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function rr(e, t, r) {
  const n = tr(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return er[n];
}
function Ue(e, t = !1) {
  const r = document.activeElement;
  for (const n of e)
    if (n === r || (n.focus({ preventScroll: t }), document.activeElement !== r))
      return;
}
function nr(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var or = Fe, sr = Le;
function ir(e, t) {
  return d.useReducer((r, n) => t[r][n] ?? r, e);
}
var De = (e) => {
  const { present: t, children: r } = e, n = cr(t), o = typeof r == "function" ? r({ present: n.isPresent }) : d.Children.only(r), s = B(n.ref, ur(o));
  return typeof r == "function" || n.isPresent ? d.cloneElement(o, { ref: s }) : null;
};
De.displayName = "Presence";
function cr(e) {
  const [t, r] = d.useState(), n = d.useRef({}), o = d.useRef(e), s = d.useRef("none"), i = e ? "mounted" : "unmounted", [c, a] = ir(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const u = U(n.current);
    s.current = c === "mounted" ? u : "none";
  }, [c]), Z(() => {
    const u = n.current, p = o.current;
    if (p !== e) {
      const h = s.current, g = U(u);
      e ? a("MOUNT") : g === "none" || (u == null ? void 0 : u.display) === "none" ? a("UNMOUNT") : a(p && h !== g ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, a]), Z(() => {
    if (t) {
      let u;
      const p = t.ownerDocument.defaultView ?? window, f = (g) => {
        const m = U(n.current).includes(g.animationName);
        if (g.target === t && m && (a("ANIMATION_END"), !o.current)) {
          const x = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = p.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = x);
          });
        }
      }, h = (g) => {
        g.target === t && (s.current = U(n.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        p.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      a("ANIMATION_END");
  }, [t, a]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function U(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function ur(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var te = "Tabs", [ar, lr] = X(te, [
  Ne
]), Be = Ne(), [dr, re] = ar(te), ne = d.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: r,
      value: n,
      onValueChange: o,
      defaultValue: s,
      orientation: i = "horizontal",
      dir: c,
      activationMode: a = "automatic",
      ...u
    } = e, p = Me(c), [f, h] = Oe({
      prop: n,
      onChange: o,
      defaultProp: s
    });
    return /* @__PURE__ */ w(
      dr,
      {
        scope: r,
        baseId: $e(),
        value: f,
        onValueChange: h,
        orientation: i,
        dir: p,
        activationMode: a,
        children: /* @__PURE__ */ w(
          L.div,
          {
            dir: p,
            "data-orientation": i,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
ne.displayName = te;
var ke = "TabsList", oe = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, loop: n = !0, ...o } = e, s = re(ke, r), i = Be(r);
    return /* @__PURE__ */ w(
      or,
      {
        asChild: !0,
        ...i,
        orientation: s.orientation,
        dir: s.dir,
        loop: n,
        children: /* @__PURE__ */ w(
          L.div,
          {
            role: "tablist",
            "aria-orientation": s.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
oe.displayName = ke;
var Ge = "TabsTrigger", se = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: n, disabled: o = !1, ...s } = e, i = re(Ge, r), c = Be(r), a = qe(i.baseId, n), u = Ke(i.baseId, n), p = n === i.value;
    return /* @__PURE__ */ w(
      sr,
      {
        asChild: !0,
        ...c,
        focusable: !o,
        active: p,
        children: /* @__PURE__ */ w(
          L.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": p,
            "aria-controls": u,
            "data-state": p ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: a,
            ...s,
            ref: t,
            onMouseDown: _(e.onMouseDown, (f) => {
              !o && f.button === 0 && f.ctrlKey === !1 ? i.onValueChange(n) : f.preventDefault();
            }),
            onKeyDown: _(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && i.onValueChange(n);
            }),
            onFocus: _(e.onFocus, () => {
              const f = i.activationMode !== "manual";
              !p && !o && f && i.onValueChange(n);
            })
          }
        )
      }
    );
  }
);
se.displayName = Ge;
var We = "TabsContent", ie = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: n, forceMount: o, children: s, ...i } = e, c = re(We, r), a = qe(c.baseId, n), u = Ke(c.baseId, n), p = n === c.value, f = d.useRef(p);
    return d.useEffect(() => {
      const h = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ w(De, { present: o || p, children: ({ present: h }) => /* @__PURE__ */ w(
      L.div,
      {
        "data-state": p ? "active" : "inactive",
        "data-orientation": c.orientation,
        role: "tabpanel",
        "aria-labelledby": a,
        hidden: !h,
        id: u,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: h && s
      }
    ) });
  }
);
ie.displayName = We;
function qe(e, t) {
  return `${e}-trigger-${t}`;
}
function Ke(e, t) {
  return `${e}-content-${t}`;
}
var fr = ne, pr = oe, hr = se, mr = ie;
const gr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Content: mr,
  List: pr,
  Root: fr,
  Tabs: ne,
  TabsContent: ie,
  TabsList: oe,
  TabsTrigger: se,
  Trigger: hr,
  createTabsScope: lr
}, Symbol.toStringTag, { value: "Module" }));
var O = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ze(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yr = 1 / 0, vr = "[object Symbol]", br = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, xr = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, W = "\\ud800-\\udfff", Je = "\\u0300-\\u036f\\ufe20-\\ufe23", Ze = "\\u20d0-\\u20f0", He = "\\u2700-\\u27bf", Ve = "a-z\\xdf-\\xf6\\xf8-\\xff", Cr = "\\xac\\xb1\\xd7\\xf7", Sr = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Er = "\\u2000-\\u206f", wr = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Ye = "A-Z\\xc0-\\xd6\\xd8-\\xde", Qe = "\\ufe0e\\ufe0f", Xe = Cr + Sr + Er + wr, ce = "['’]", Tr = "[" + W + "]", he = "[" + Xe + "]", k = "[" + Je + Ze + "]", et = "\\d+", Rr = "[" + He + "]", tt = "[" + Ve + "]", rt = "[^" + W + Xe + et + He + Ve + Ye + "]", V = "\\ud83c[\\udffb-\\udfff]", Ar = "(?:" + k + "|" + V + ")", nt = "[^" + W + "]", ue = "(?:\\ud83c[\\udde6-\\uddff]){2}", ae = "[\\ud800-\\udbff][\\udc00-\\udfff]", F = "[" + Ye + "]", ot = "\\u200d", me = "(?:" + tt + "|" + rt + ")", _r = "(?:" + F + "|" + rt + ")", ge = "(?:" + ce + "(?:d|ll|m|re|s|t|ve))?", ye = "(?:" + ce + "(?:D|LL|M|RE|S|T|VE))?", st = Ar + "?", it = "[" + Qe + "]?", Ir = "(?:" + ot + "(?:" + [nt, ue, ae].join("|") + ")" + it + st + ")*", ct = it + st + Ir, $r = "(?:" + [Rr, ue, ae].join("|") + ")" + ct, Or = "(?:" + [nt + k + "?", k, ue, ae, Tr].join("|") + ")", Mr = RegExp(ce, "g"), Pr = RegExp(k, "g"), Nr = RegExp(V + "(?=" + V + ")|" + Or + ct, "g"), Fr = RegExp([
  F + "?" + tt + "+" + ge + "(?=" + [he, F, "$"].join("|") + ")",
  _r + "+" + ye + "(?=" + [he, F + me, "$"].join("|") + ")",
  F + "?" + me + "+" + ge,
  F + "+" + ye,
  et,
  $r
].join("|"), "g"), jr = RegExp("[" + ot + W + Je + Ze + Qe + "]"), Lr = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Ur = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "ss"
}, Dr = typeof O == "object" && O && O.Object === Object && O, Br = typeof self == "object" && self && self.Object === Object && self, kr = Dr || Br || Function("return this")();
function Gr(e, t, r, n) {
  var o = -1, s = e ? e.length : 0;
  for (n && s && (r = e[++o]); ++o < s; )
    r = t(r, e[o], o, e);
  return r;
}
function Wr(e) {
  return e.split("");
}
function qr(e) {
  return e.match(br) || [];
}
function Kr(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var zr = Kr(Ur);
function ut(e) {
  return jr.test(e);
}
function Jr(e) {
  return Lr.test(e);
}
function Zr(e) {
  return ut(e) ? Hr(e) : Wr(e);
}
function Hr(e) {
  return e.match(Nr) || [];
}
function Vr(e) {
  return e.match(Fr) || [];
}
var Yr = Object.prototype, Qr = Yr.toString, ve = kr.Symbol, be = ve ? ve.prototype : void 0, xe = be ? be.toString : void 0;
function Xr(e, t, r) {
  var n = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var s = Array(o); ++n < o; )
    s[n] = e[n + t];
  return s;
}
function en(e) {
  if (typeof e == "string")
    return e;
  if (sn(e))
    return xe ? xe.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -yr ? "-0" : t;
}
function tn(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : Xr(e, t, r);
}
function rn(e) {
  return function(t) {
    t = q(t);
    var r = ut(t) ? Zr(t) : void 0, n = r ? r[0] : t.charAt(0), o = r ? tn(r, 1).join("") : t.slice(1);
    return n[e]() + o;
  };
}
function nn(e) {
  return function(t) {
    return Gr(dn(an(t).replace(Mr, "")), e, "");
  };
}
function on(e) {
  return !!e && typeof e == "object";
}
function sn(e) {
  return typeof e == "symbol" || on(e) && Qr.call(e) == vr;
}
function q(e) {
  return e == null ? "" : en(e);
}
var cn = nn(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? un(t) : t);
});
function un(e) {
  return ln(q(e).toLowerCase());
}
function an(e) {
  return e = q(e), e && e.replace(xr, zr).replace(Pr, "");
}
var ln = rn("toUpperCase");
function dn(e, t, r) {
  return e = q(e), t = r ? void 0 : t, t === void 0 ? Jr(e) ? Vr(e) : qr(e) : e.match(t) || [];
}
var fn = cn;
const at = /* @__PURE__ */ ze(fn);
var pn = 1 / 0, hn = "[object Symbol]", le = "\\ud800-\\udfff", lt = "\\u0300-\\u036f\\ufe20-\\ufe23", dt = "\\u20d0-\\u20f0", ft = "\\ufe0e\\ufe0f", mn = "[" + le + "]", Y = "[" + lt + dt + "]", Q = "\\ud83c[\\udffb-\\udfff]", gn = "(?:" + Y + "|" + Q + ")", pt = "[^" + le + "]", ht = "(?:\\ud83c[\\udde6-\\uddff]){2}", mt = "[\\ud800-\\udbff][\\udc00-\\udfff]", gt = "\\u200d", yt = gn + "?", vt = "[" + ft + "]?", yn = "(?:" + gt + "(?:" + [pt, ht, mt].join("|") + ")" + vt + yt + ")*", vn = vt + yt + yn, bn = "(?:" + [pt + Y + "?", Y, ht, mt, mn].join("|") + ")", xn = RegExp(Q + "(?=" + Q + ")|" + bn + vn, "g"), Cn = RegExp("[" + gt + le + lt + dt + ft + "]"), Sn = typeof O == "object" && O && O.Object === Object && O, En = typeof self == "object" && self && self.Object === Object && self, wn = Sn || En || Function("return this")();
function Tn(e) {
  return e.split("");
}
function bt(e) {
  return Cn.test(e);
}
function Rn(e) {
  return bt(e) ? An(e) : Tn(e);
}
function An(e) {
  return e.match(xn) || [];
}
var _n = Object.prototype, In = _n.toString, Ce = wn.Symbol, Se = Ce ? Ce.prototype : void 0, Ee = Se ? Se.toString : void 0;
function $n(e, t, r) {
  var n = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var s = Array(o); ++n < o; )
    s[n] = e[n + t];
  return s;
}
function On(e) {
  if (typeof e == "string")
    return e;
  if (Fn(e))
    return Ee ? Ee.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -pn ? "-0" : t;
}
function Mn(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : $n(e, t, r);
}
function Pn(e) {
  return function(t) {
    t = jn(t);
    var r = bt(t) ? Rn(t) : void 0, n = r ? r[0] : t.charAt(0), o = r ? Mn(r, 1).join("") : t.slice(1);
    return n[e]() + o;
  };
}
function Nn(e) {
  return !!e && typeof e == "object";
}
function Fn(e) {
  return typeof e == "symbol" || Nn(e) && In.call(e) == hn;
}
function jn(e) {
  return e == null ? "" : On(e);
}
var Ln = Pn("toUpperCase"), Un = Ln;
const xt = /* @__PURE__ */ ze(Un);
(function(e) {
  typeof globalThis != "object" && (this ? t() : (e.defineProperty(e.prototype, "_T_", {
    configurable: !0,
    get: t
  }), _T_));
  function t() {
    var r = this || self;
    r.globalThis = r, delete e.prototype._T_;
  }
})(Object);
const Dn = "application/json", Ct = "Content-Type", N = Symbol(), St = Symbol();
function we(e = {}) {
  var t;
  const r = e instanceof Array ? Object.fromEntries(e) : e;
  return (t = Object.entries(r).find(([n]) => n.toLowerCase() === Ct.toLowerCase())) === null || t === void 0 ? void 0 : t[1];
}
function Te(e) {
  return /^application\/.*json.*/.test(e);
}
const P = function(e, t, r = !1) {
  return Object.entries(t).reduce((n, [o, s]) => {
    const i = e[o];
    return Array.isArray(i) && Array.isArray(s) ? n[o] = r ? [...i, ...s] : s : typeof i == "object" && typeof s == "object" ? n[o] = P(i, s, r) : n[o] = s, n;
  }, { ...e });
}, j = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(e, t = !0, r = !1, ...n) {
    const o = this.polyfills[e] || (typeof self < "u" ? self[e] : null) || (typeof global < "u" ? global[e] : null);
    if (t && !o)
      throw new Error(e + " is not defined");
    return r && o ? new o(...n) : o;
  }
};
function Bn(e, t = !1) {
  j.options = t ? e : P(j.options, e);
}
function kn(e, t = !1) {
  j.polyfills = t ? e : P(j.polyfills, e);
}
function Gn(e) {
  j.errorType = e;
}
const Wn = (e) => (t) => e.reduceRight((r, n) => n(r), t) || t;
class Et extends Error {
}
const qn = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  e = e._addons.reduce((l, b) => b.beforeRequest && b.beforeRequest(l, e._options, t) || l, e);
  const { _url: r, _options: n, _config: o, _catchers: s, _resolvers: i, _middlewares: c, _addons: a } = e, u = new Map(s), p = P(o.options, n);
  let f = r;
  const h = Wn(c)((l, b) => (f = l, o.polyfill("fetch")(l, b)))(r, p), g = new Error(), y = h.catch((l) => {
    throw { [N]: l };
  }).then((l) => {
    var b;
    if (!l.ok) {
      const S = new Et();
      if (S.cause = g, S.stack = S.stack + `
CAUSE: ` + g.stack, S.response = l, S.status = l.status, S.url = f, l.type === "opaque")
        throw S;
      const T = o.errorType === "json" || ((b = l.headers.get("Content-Type")) === null || b === void 0 ? void 0 : b.split(";")[0]) === "application/json";
      return (o.errorType ? T ? l.text() : l[o.errorType]() : Promise.resolve(l.body)).then((E) => {
        throw S.message = typeof E == "string" ? E : l.statusText, E && (T && typeof E == "string" ? (S.text = E, S.json = JSON.parse(E)) : S[o.errorType] = E), S;
      });
    }
    return l;
  }), m = (l) => l.catch((b) => {
    const S = Object.prototype.hasOwnProperty.call(b, N), T = S ? b[N] : b, $ = (T == null ? void 0 : T.status) && u.get(T.status) || u.get(T == null ? void 0 : T.name) || S && u.has(N) && u.get(N);
    if ($)
      return $(T, e);
    const E = u.get(St);
    if (E)
      return E(T, e);
    throw T;
  }), x = (l) => (b) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ m(l ? y.then((S) => S && S[l]()).then((S) => b ? b(S) : S) : y.then((S) => b ? b(S) : S)), v = {
    _wretchReq: e,
    _fetchReq: h,
    _sharedState: t,
    res: x(null),
    json: x("json"),
    blob: x("blob"),
    formData: x("formData"),
    arrayBuffer: x("arrayBuffer"),
    text: x("text"),
    error(l, b) {
      return u.set(l, b), this;
    },
    badRequest(l) {
      return this.error(400, l);
    },
    unauthorized(l) {
      return this.error(401, l);
    },
    forbidden(l) {
      return this.error(403, l);
    },
    notFound(l) {
      return this.error(404, l);
    },
    timeout(l) {
      return this.error(408, l);
    },
    internalError(l) {
      return this.error(500, l);
    },
    fetchError(l) {
      return this.error(N, l);
    }
  }, C = a.reduce((l, b) => ({
    ...l,
    ...typeof b.resolver == "function" ? b.resolver(l) : b.resolver
  }), v);
  return i.reduce((l, b) => b(l, e), C);
}, Kn = {
  _url: "",
  _options: {},
  _config: j,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(e) {
    return { ...this, _addons: [...this._addons, e], ...e.wretch };
  },
  errorType(e) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: e
      }
    };
  },
  polyfills(e, t = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: t ? e : P(this._config.polyfills, e)
      }
    };
  },
  url(e, t = !1) {
    if (t)
      return { ...this, _url: e };
    const r = this._url.split("?");
    return {
      ...this,
      _url: r.length > 1 ? r[0] + e + "?" + r[1] : this._url + e
    };
  },
  options(e, t = !1) {
    return { ...this, _options: t ? e : P(this._options, e) };
  },
  headers(e) {
    const t = e ? Array.isArray(e) ? Object.fromEntries(e) : "entries" in e ? Object.fromEntries(e.entries()) : e : {};
    return { ...this, _options: P(this._options, { headers: t }) };
  },
  accept(e) {
    return this.headers({ Accept: e });
  },
  content(e) {
    return this.headers({ [Ct]: e });
  },
  auth(e) {
    return this.headers({ Authorization: e });
  },
  catcher(e, t) {
    const r = new Map(this._catchers);
    return r.set(e, t), { ...this, _catchers: r };
  },
  catcherFallback(e) {
    return this.catcher(St, e);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(e, t = !1) {
    return { ...this, _resolvers: t ? [e] : [...this._resolvers, e] };
  },
  defer(e, t = !1) {
    return {
      ...this,
      _deferred: t ? [e] : [...this._deferred, e]
    };
  },
  middlewares(e, t = !1) {
    return {
      ...this,
      _middlewares: t ? e : [...this._middlewares, ...e]
    };
  },
  fetch(e = this._options.method, t = "", r = null) {
    let n = this.url(t).options({ method: e });
    const o = we(n._options.headers), s = this._config.polyfill("FormData", !1), i = typeof r == "object" && !(s && r instanceof s) && (!n._options.headers || !o || Te(o));
    return n = r ? i ? n.json(r, o) : n.body(r) : n, qn(n._deferred.reduce((c, a) => a(c, c._url, c._options), n));
  },
  get(e = "") {
    return this.fetch("GET", e);
  },
  delete(e = "") {
    return this.fetch("DELETE", e);
  },
  put(e, t = "") {
    return this.fetch("PUT", t, e);
  },
  post(e, t = "") {
    return this.fetch("POST", t, e);
  },
  patch(e, t = "") {
    return this.fetch("PATCH", t, e);
  },
  head(e = "") {
    return this.fetch("HEAD", e);
  },
  opts(e = "") {
    return this.fetch("OPTIONS", e);
  },
  body(e) {
    return { ...this, _options: { ...this._options, body: e } };
  },
  json(e, t) {
    const r = we(this._options.headers);
    return this.content(t || Te(r) && r || Dn).body(JSON.stringify(e));
  }
};
function I(e = "", t = {}) {
  return { ...Kn, _url: e, _options: t };
}
I.default = I;
I.options = Bn;
I.errorType = Gn;
I.polyfills = kn;
I.WretchError = Et;
const zn = (e, t) => t.skipDedupe || t.method !== "GET", Jn = (e, t) => t.method + "@" + e, Zn = (e) => e.clone(), wt = ({ skip: e = zn, key: t = Jn, resolver: r = Zn } = {}) => {
  const n = /* @__PURE__ */ new Map();
  return (o) => (s, i) => {
    if (e(s, i))
      return o(s, i);
    const c = t(s, i);
    if (!n.has(c))
      n.set(c, []);
    else
      return new Promise((a, u) => {
        n.get(c).push([a, u]);
      });
    try {
      return o(s, i).then((a) => (n.get(c).forEach(([u]) => u(r(a))), n.delete(c), a)).catch((a) => {
        throw n.get(c).forEach(([, u]) => u(a)), n.delete(c), a;
      });
    } catch (a) {
      return n.delete(c), Promise.reject(a);
    }
  };
}, Hn = (e, t) => t.skipCache || t.method !== "GET", Vn = (e, t) => t.method + "@" + e, Yn = () => !1, Qn = () => null, Xn = (e) => e.ok, eo = ({ throttle: e = 1e3, skip: t = Hn, key: r = Vn, clear: n = Yn, invalidate: o = Qn, condition: s = Xn, flagResponseOnCacheHit: i = "__cached" } = {}) => {
  const c = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Set(), p = (h) => {
    e && !u.has(h) && (u.add(h), setTimeout(() => {
      u.delete(h);
    }, e));
  }, f = (h) => (g, y) => {
    const m = r(g, y);
    let x = o(g, y);
    if (x && (x instanceof Array || (x = [x]), x.forEach((v) => {
      typeof v == "string" ? c.delete(v) : v instanceof RegExp && c.forEach((C, l) => {
        v.test(l) && c.delete(l);
      });
    })), n(g, y) && c.clear(), t(g, y))
      return h(g, y);
    if (u.has(m)) {
      if (c.has(m)) {
        const v = c.get(m).clone();
        return i && Object.defineProperty(v, i, {
          value: m,
          enumerable: !1
        }), Promise.resolve(v);
      } else if (a.has(m))
        return new Promise((v, C) => {
          a.get(m).push([v, C]);
        });
    }
    return a.has(m) || a.set(m, []), p(m), h(g, y).then((v) => (s(v.clone()) && c.set(m, v.clone()), a.get(m).forEach(([C]) => C(v.clone())), a.delete(m), v)).catch((v) => {
      throw a.get(m).forEach(([, C]) => C(v)), a.delete(m), v;
    });
  };
  return f.cacheResponse = function(h, g) {
    p(h), c.set(h, g);
  }, f.cache = c, f.inflight = a, f.throttling = u, f;
}, to = (e, t) => e * t, ro = (e) => e && e.ok, Tt = ({ delayTimer: e = 500, delayRamp: t = to, maxAttempts: r = 10, until: n = ro, onRetry: o = null, retryOnNetworkError: s = !1, resolveWithLatestResponse: i = !1, skip: c } = {}) => (a) => (u, p) => {
  let f = 0;
  if (c && c(u, p))
    return a(u, p);
  const h = (g, y) => Promise.resolve(n(g, y)).then((m) => m ? g && i ? g : y ? Promise.reject(y) : g : (f++, !r || f <= r ? new Promise((x) => {
    const v = t(e, f);
    setTimeout(() => {
      typeof o == "function" ? Promise.resolve(o({
        response: g,
        error: y,
        url: u,
        options: p
      })).then((C = {}) => {
        var l, b;
        x(a((l = C && C.url) !== null && l !== void 0 ? l : u, (b = C && C.options) !== null && b !== void 0 ? b : p));
      }) : x(a(u, p));
    }, v);
  }).then(h).catch((x) => {
    if (!s)
      throw x;
    return h(null, x);
  }) : g && i ? g : Promise.reject(y || new Error("Number of attempts exceeded."))));
  return a(u, p).then(h).catch((g) => {
    if (!s)
      throw g;
    return h(null, g);
  });
};
class no extends Error {
  constructor(t) {
    super(`Dependency ${t} not found in provided dependency map.`), this.name = "DependencyMissingError";
  }
}
class oo extends Error {
  constructor(t, r) {
    super(`Timeout while fetching umd bundle ${t}`), this.name = "FetchUmdBundleTimeoutError", this.cause = r;
  }
}
class so extends Error {
  constructor(t, r) {
    super(`Failed to fetch umd bundle ${t}`), this.name = "FetchUmdBundleError", this.cause = r;
  }
}
class io extends Error {
  constructor(t, r) {
    super(`Failed to evaluate umd bundle for ${t}`), this.name = "EvalUmdBundleError", this.cause = r;
  }
}
class co extends Error {
  constructor(t) {
    super(`Module for ${t} was undefined`), this.name = "ModuleUndefinedError";
  }
}
const uo = I().middlewares([
  wt(),
  Tt({
    delayRamp: (e, t) => e * t,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  }),
  eo({
    key: (e, t) => t.headers["X-Cache-Key"],
    throttle: 1e3 * 60 * 60 * 24 * 365
    // 1 year
  })
]), ao = I().middlewares([
  wt(),
  Tt({
    delayRamp: (e, t) => e * t,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  })
]), Rt = async ({
  bundleLoader: e,
  bundleUrl: t,
  cxComponentName: r,
  dependenciesMap: n,
  ...o
}, s) => {
  try {
    return await e({
      bundleUrl: t,
      cxComponentName: r,
      dependenciesMap: n,
      ...o
    });
  } catch (i) {
    throw s && s(), i;
  }
}, lo = async ({
  baseCacheKey: e,
  bundleUrl: t,
  cxComponentName: r,
  dependenciesMap: n,
  isSnapshot: o
}) => {
  let s;
  try {
    s = await (o ? ao : uo).url(t).headers({
      "X-Cache-Key": e
    }).get().timeout((a) => {
      throw new oo(t, a);
    }).text();
  } catch (i) {
    throw new so(t, i);
  }
  try {
    return fo(e, r, s, n, o);
  } catch (i) {
    throw new io(r, i);
  }
}, Re = /* @__PURE__ */ new Map(), fo = (e, t, r, n, o) => {
  if (!o) {
    const c = Re.get(e);
    if (c)
      return c;
  }
  const s = globalThis.define;
  let i;
  globalThis.define = (c, a) => {
    i = a(
      ...c.map((u) => {
        const p = n[u];
        if (!p)
          throw new no(u);
        return p;
      })
    );
  }, globalThis.define.amd = !0;
  try {
    new Function(r)();
  } finally {
    globalThis.define = s;
  }
  if (!i)
    throw new co(t);
  return o || Re.set(e, i), i;
}, po = async ({
  bundleUrl: e,
  cxComponentName: t,
  dependenciesMap: r
}) => {
  const n = document.createElement("script");
  n.src = e;
  const o = new Promise((s, i) => {
    n.addEventListener("load", () => {
      s(window.cxComponentExports[t]);
    }), n.addEventListener("error", (c) => {
      document.head.contains(n) && document.head.removeChild(n), i(c.error);
    });
  });
  return window.cxComponentDeps = {
    ...window.cxComponentDeps,
    ...r
  }, document.head.appendChild(n), o;
}, ho = (e) => Rt({
  ...e,
  bundleLoader: lo
}), mo = (e) => Rt({
  bundleLoader: po,
  bundleUrl: e.bundleUrl,
  cxComponentName: e.cxComponentName,
  dependenciesMap: e.dependenciesMap,
  isSnapshot: e.isSnapshot
}), go = async (e, { contractVersion: t, name: r }, { dependenciesMap: n = {}, insertCss: o = !0 } = {}) => {
  const s = xt(at(r)), i = `${e}/modules/${r}/${s}-${t}-umd.js`, c = `${e}/modules/${r}/${s}-${t}-style.css`, u = window[`cxComponent${s}Config`] ?? {
    cssBundle: c,
    dehydratedState: void 0,
    umdBundle: i
  }, p = await mo({
    baseCacheKey: `${s}-${t}-${e}`,
    bundleUrl: u.umdBundle,
    cxComponentName: s,
    dependenciesMap: n,
    isSnapshot: vo(t)
  });
  if (!o)
    return {
      Component: p,
      cssBundle: u.cssBundle,
      dehydratedState: u.dehydratedState
    };
  if (u.cssBundle && !yo(u.cssBundle)) {
    const f = document.createElement("link");
    f.rel = "stylesheet", f.href = c, document.head.appendChild(f);
  }
  return {
    Component: p,
    cssBundle: u.cssBundle,
    dehydratedState: u.dehydratedState
  };
}, yo = (e) => !!document.querySelector(`link[rel="stylesheet"][href="${e}"]`), vo = (e) => e.startsWith("0.0.0"), bo = async (e, { contractVersion: t, dehydratedState: r, initialZustandState: n, name: o }, { dependenciesMap: s = {} } = {}) => {
  const i = xt(at(o)), c = `${e}/modules/${o}/${i}-${t}-umd.js`, a = `${e}/modules/${o}/${i}-${t}-style.css`, u = await ho({
    baseCacheKey: `${i}-${t}-${e}`,
    bundleUrl: c,
    cxComponentName: i,
    dependenciesMap: s,
    isSnapshot: xo(t)
  }), p = `window["cxComponent${i}Config"] = ${JSON.stringify({
    cssBundle: a,
    dehydratedState: r,
    initialZustandState: n,
    umdBundle: c
  })}`, f = `
${a ? `<link rel="stylesheet" href="${a}">` : ""}
<link rel="preload" href="${c}" as="script">
<script>${p}<\/script>`;
  return {
    Component: u,
    dehydratedState: r,
    initialZustandState: n,
    ssrConfig: {
      cssBundle: a,
      jsBundle: c,
      moduleConfigScript: p
    },
    stringToAddToSsrResult: f
  };
}, xo = (e) => e.startsWith("0.0.0");
class Co extends Error {
  constructor(r, n, o, s, i) {
    super(r);
    R(this, "statusCode");
    R(this, "endpoint");
    R(this, "args");
    R(this, "response");
    this.name = "ApiError", this.statusCode = n, this.endpoint = o, this.args = s, this.response = i;
  }
}
class de extends Co {
  constructor(t, r, n, o) {
    super(`Client error ${t} occurred while fetching ${r}`, t, r, n, o), this.name = "Api4xxError";
  }
}
class So extends de {
  constructor(t, r, n) {
    super(404, t, r, n), this.name = "Api404Error";
  }
}
class Eo extends de {
  constructor(t, r, n) {
    super(400, t, r, n), this.name = "Api400Error";
  }
}
class wo {
  constructor(t = {}) {
    R(this, "logger");
    R(this, "notFoundLogLevel");
    R(this, "badRequestLogLevel");
    R(this, "other4xxLogLevel");
    this.logger = t.logger, this.notFoundLogLevel = t.notFoundLogLevel || "info", this.badRequestLogLevel = t.badRequestLogLevel || "warn", this.other4xxLogLevel = t.other4xxLogLevel || "warn";
  }
  log(t, r, n) {
    this.logger && this.logger[t](r, n);
  }
  async handleApiError(t, r, n) {
    if (!(t instanceof Response))
      throw t;
    const { status: o } = t;
    if (o === 404) {
      const s = new So(r, n, t);
      return this.log(this.notFoundLogLevel, s.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    if (o === 400) {
      const s = new Eo(r, n, t);
      return this.log(this.badRequestLogLevel, s.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    if (o >= 400 && o < 500) {
      const s = new de(o, r, n, t);
      return this.log(this.other4xxLogLevel, s.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    throw t;
  }
}
const To = (e, t) => {
  const r = new wo(t);
  return e.catcher(404, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(400, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(401, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(403, async (n) => (await r.handleApiError(n.response, n.url), null)).catcherFallback(async (n) => {
    if (n.status >= 400 && n.status < 500)
      return await r.handleApiError(n.response, n.url), null;
    throw n;
  });
}, Ro = (e) => e ? e.split(",").map((t) => t.trim()).filter(Boolean).join(",") : "", Ao = (e) => {
  const t = Object.entries(e).filter(([, r]) => r !== void 0).sort(([r], [n]) => r.localeCompare(n)).map(([r, n]) => [r, String(n)]);
  return new URLSearchParams(t).toString();
}, _o = async (e, t, r) => {
  var m;
  const { apiKey: n, countryCode: o, deviceType: s, offerIds: i, offerLimit: c, sortBy: a, subdivisionCode: u, vcId: p } = t;
  if (!n)
    throw (m = r == null ? void 0 : r.logger) == null || m.error("No apiKey provided"), new Error("No apiKey provided.");
  const f = p ? { variationContainerId: p } : i ? { offerIds: Ro(i) } : void 0, h = Ao({
    ...f,
    ...s && { deviceType: s },
    ...c ? { limit: c } : {},
    ...a ? { sort: a } : {}
  }), g = new URL(`${e}/v1/offers?${h}`);
  return To(
    I(g.toString(), {
      headers: {
        accept: "application/json",
        "api-key": n,
        "content-type": "application/json",
        ...o && { "country-code": o },
        ...u && { "subdivision-code": u }
      }
    }),
    r
  ).get().json();
}, Io = async (e = "https://offers-delivery-api-stg.core.occloud.io", t, r = {}) => {
  try {
    return await _o(e, t, r);
  } catch (n) {
    throw r.logger && r.logger.error(n), n;
  }
}, $o = ({ apiKey: e, offerIds: t, vcId: r }) => ["offers-grouped", e, t ? "offerIds" : "vcId", t || r], Oo = "@cx-modules/offers-grouped", At = "3.0.0", [, _t] = Oo.split("/"), Uo = async (e, { dataApiEndpoint: t, ...r }, n, o) => {
  var c;
  const s = new D.QueryClient();
  let i;
  try {
    await s.prefetchQuery({
      queryFn: () => Io(t, r, o),
      queryKey: $o(r)
    });
  } catch (a) {
    (c = o == null ? void 0 : o.logger) == null || c.error(a);
  } finally {
    i = D.dehydrate(s);
  }
  return await bo(
    e,
    {
      contractVersion: At,
      dehydratedState: i,
      name: _t,
      ...n && { meta: n }
    },
    {
      dependenciesMap: {
        "@radix-ui/react-tabs": gr,
        "@tanstack/react-query": D,
        react: A,
        "react/jsx-dev-runtime": Ae,
        "react/jsx-runtime": _e,
        "react-dom": Ft
      },
      ...o
    }
  );
}, Do = async (e, t, r) => await go(
  e,
  {
    contractVersion: At,
    name: _t,
    ...t && { meta: t }
  },
  {
    dependenciesMap: {
      "@tanstack/react-query": D,
      react: A,
      "react/jsx-dev-runtime": Ae,
      "react/jsx-runtime": _e
    },
    ...r
  }
);
export {
  Do as loadClient,
  Uo as loadServer
};
